import React from 'react';
import { Card, Form, Checkbox, Typography } from 'antd';
import { ProFormRadio } from '@ant-design/pro-form';
import PropTypes from 'prop-types';
import { SCOPE_TYPES } from 'constants/scopes';

const { Title, Text } = Typography;
const gridStyle = {
  width: '100%',
};
const scopeLevelOptions = [
  {
    label: 'All',
    value: 'ALL',
  },
  {
    label: 'Faculty',
    value: 'FACULTY',
  },
  {
    label: 'Department',
    value: 'DEPARTMENT',
  },
  {
    label: 'None',
    value: 'NONE',
  },
];
const requiredSelectRules = [{ required: true, message: 'Please select!' }];
const ScopeLevelRadioGroup = ({ data }) =>
  data.map(({ name, label }) => (
    <ProFormRadio.Group
      key={name}
      name={name}
      radioType="button"
      label={label}
      options={scopeLevelOptions}
      rules={requiredSelectRules}
    />
  ));

const RolePremissionsForm = ({
  includeViewProject,
  includeReportControlType,
  showSystemwiseSetting,
}) => {
  return (
    <Card className="premission-form" style={{ marginBottom: '24px' }}>
      {includeViewProject && (
        <Card.Grid hoverable={false} style={gridStyle}>
          <Title level={5}>Projects</Title>
          <ProFormRadio.Group
            name="VIEW_PROJECT"
            radioType="button"
            label="View projects &amp; projects' profile"
            options={[
              {
                label: 'Active',
                value: 'VIEW_ACTIVE_PROJECT',
              },
              {
                label: 'All',
                value: 'VIEW_ALL_PROJECT',
              },
            ]}
            rules={requiredSelectRules}
          />

          <ScopeLevelRadioGroup
            data={[
              {
                name: 'VIEW_PROJECT_PROPOSAL',
                label: "View projects's proposal",
              },
              {
                name: 'VIEW_HISTORY_LOG_BY_PMS',
                label: "View project's history log by PMS admin",
              },
            ]}
          />
        </Card.Grid>
      )}
      <Card.Grid hoverable={false} style={gridStyle}>
        <Title level={5}>Team</Title>
        <ScopeLevelRadioGroup
          data={[
            {
              name: 'VIEW_TEAM',
              label: "View projects's team",
            },
            {
              name: 'WRITE_TEAM',
              label: "Add or edit projects's team",
            },
          ]}
        />
      </Card.Grid>
      <Card.Grid hoverable={false} style={gridStyle}>
        <Title level={5}>Budget &amp; Virement</Title>
        <ScopeLevelRadioGroup
          data={[
            {
              name: 'VIEW_BUDGET',
              label: "View projects's budget",
            },
            {
              name: 'WRITE_BUDGET',
              label: "Add and edit projects's budget",
            },
            {
              name: 'VIEW_VIREMENT',
              label:
                "View projects's virement, must match the level of view project's budget",
            },
            {
              name: 'WRITE_VIREMENT',
              label: "Apply projects's virement",
            },
            {
              name: 'WRITE_VIREMENT_WITH_CUSTOM_DATE',
              label: "Apply projects's virement with custom date",
            },
            {
              name: 'VOID_VIREMENT',
              label: 'Void approved or rejected virement',
            },
          ]}
        />
      </Card.Grid>
      <Card.Grid hoverable={false} style={gridStyle}>
        <Title level={5}>Report Submission</Title>
        <ScopeLevelRadioGroup
          data={[
            {
              name: 'VIEW_REPORT_SUBMISSION',
              label:
                "View projects's schedule report submission & report submission ",
            },
            {
              name: 'WRITE_SCHEDULED_REPORT_SUBMISSION',
              label: 'Schedule and edit report submission',
            },
            {
              name: 'SUBMIT_REPORT',
              label: 'Submit report',
            },
            {
              name: 'SUBMIT_REPORT_WITH_CUSTOM_DATE',
              label: 'Submit report with custom date',
            },
          ]}
        />
      </Card.Grid>
      {includeReportControlType && (
        <Card.Grid hoverable={false} style={gridStyle}>
          <Title level={5}>Report Control Type</Title>
          <Text
            type="secondary"
            style={{ paddingBottom: '8px', display: 'block' }}
          >
            To determine the workflow of reviewing report submission, ask Kit /
            developer of PMS if you have any questions
          </Text>
          <ProFormRadio.Group
            key="reportControlType"
            name="reportControlType"
            radioType="button"
            options={[
              {
                label: 'LTC Chair',
                value: 'LTC_CHAIR',
              },
              {
                label: 'Faculty Dean',
                value: 'FDEAN',
              },
              {
                label: 'FLTC Chair',
                value: 'FLTC_CHAIR',
              },
              {
                label: 'School Dean',
                value: 'SDEAN',
              },
              {
                label: 'SLTC Chair',
                value: 'SLTC_CHAIR',
              },
              {
                label: 'Head/Director',
                value: 'HEAD',
              },
              {
                label: 'DLTC Chair',
                value: 'DLTC_CHAIR',
              },
              {
                label: 'General',
                value: 'GENERAL',
              },
            ]}
            rules={requiredSelectRules}
          />
        </Card.Grid>
      )}
      <Card.Grid hoverable={false} style={gridStyle}>
        <Title level={5}>Proposal Revision</Title>
        <ScopeLevelRadioGroup
          data={[
            {
              name: 'VIEW_PROPOSAL_REVISION',
              label: "View projects's proposal revision",
            },
            {
              name: 'WRITE_PROPOSAL_REVISION',
              label: "Apply projects's proposal revision",
            },
            {
              name: 'WRITE_PROPOSAL_REVISION_WITH_CUSTOM_DATE',
              label: "Apply projects's proposal revision with custom date",
            },
            {
              name: 'VOID_PROPOSAL_REVISION',
              label: 'Void approved or rejected proposal revision',
            },
          ]}
        />
      </Card.Grid>
      <Card.Grid hoverable={false} style={gridStyle}>
        <Title level={5}>Extension</Title>
        <ScopeLevelRadioGroup
          data={[
            {
              name: 'VIEW_EXTENSION',
              label: "View projects's extension",
            },
            {
              name: 'WRITE_EXTENSION',
              label: "Apply projects's extension",
            },
            {
              name: 'WRITE_EXTENSION_WITH_CUSTOM_DATE',
              label: "Apply projects's extension with custom date",
            },
            {
              name: 'VOID_EXTENSION',
              label: 'Void approved or rejected extension',
            },
          ]}
        />
      </Card.Grid>
      <Card.Grid hoverable={false} style={gridStyle}>
        <Title level={5}>Withdrawal</Title>
        <ScopeLevelRadioGroup
          data={[
            {
              name: 'VIEW_WITHDRAWAL',
              label: "View projects's withdrawal",
            },
            {
              name: 'WRITE_WITHDRAWAL',
              label: "Apply projects's withdrawal",
            },
            {
              name: 'WRITE_WITHDRAWAL_WITH_CUSTOM_DATE',
              label: "Apply projects's withdrawal with custom date",
            },
            {
              name: 'VOID_WITHDRAWAL',
              label: 'Void approved or rejected withdrawal',
            },
          ]}
        />
      </Card.Grid>
      <Card.Grid hoverable={false} style={gridStyle}>
        <Title level={5}>Termination</Title>
        <ScopeLevelRadioGroup
          data={[
            {
              name: 'VIEW_TERMINATION',
              label: "View projects's termination",
            },
            {
              name: 'WRITE_TERMINATION',
              label: "Apply projects's termination",
            },
            {
              name: 'WRITE_TERMINATION_WITH_CUSTOM_DATE',
              label: "Apply projects's termination with custom date",
            },
          ]}
        />
      </Card.Grid>
      {/* can add back later */}
      {showSystemwiseSetting && (
        <Card.Grid hoverable={false} style={gridStyle}>
          <Title level={5}>Annual Report</Title>
          <Form.Item name="VIEW_ANNUAL_REPORT" valuePropName="checked">
            <Checkbox>
              View annual report for role's faculty &amp; department
            </Checkbox>
          </Form.Item>
          <Form.Item name="WRITE_ANNUAL_REPORT" valuePropName="checked">
            <Checkbox>Add annual report for role's faculty</Checkbox>
          </Form.Item>
          <Form.Item name="VIEW_ALL_ANNUAL_REPORT" valuePropName="checked">
            <Checkbox>View annual report for all faculty</Checkbox>
          </Form.Item>
          <Form.Item
            name="WRITE_ANNUAL_REPORT_WITH_CUSTOM_DATE"
            valuePropName="checked"
          >
            <Checkbox>
              Add and edit annual report with custom date for all faculty
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={SCOPE_TYPES.VIEW_ANNUAL_REPORT_PROJECT}
            valuePropName="checked"
          >
            <Checkbox>View project tab in annual report</Checkbox>
          </Form.Item>
        </Card.Grid>
      )}
      {/* Pass role */}
      {showSystemwiseSetting && (
        <Card.Grid hoverable={false} style={gridStyle}>
          <Title level={5}>Pass Role</Title>
          <Form.Item name="WRITE_PASS_ROLE" valuePropName="checked">
            <Checkbox>Can pass role to other users</Checkbox>
          </Form.Item>
          <Form.Item name="WRITE_ANY_PASS_ROLE" valuePropName="checked">
            <Checkbox>Can pass role from ANY user to other users</Checkbox>
          </Form.Item>
        </Card.Grid>
      )}
      {/* Project Application */}
      {showSystemwiseSetting && (
        <Card.Grid hoverable={false} style={gridStyle}>
          <Title level={5}>Funding Application</Title>
          <ScopeLevelRadioGroup
            data={[
              {
                name: SCOPE_TYPES.VIEW_PROJECT_APPLICATION,
                label: 'View funding applications',
              },
            ]}
          />
          <Form.Item
            name={SCOPE_TYPES.ASSIGN_PROJECT_APPLICATION_ENDORSER}
            valuePropName="checked"
          >
            <Checkbox>Can assign endorser</Checkbox>
          </Form.Item>
          <Form.Item
            name={SCOPE_TYPES.WRITE_PROJECT_APPLICATION}
            valuePropName="checked"
          >
            <Checkbox>Can edit application info after endrosed</Checkbox>
          </Form.Item>
        </Card.Grid>
      )}
      {showSystemwiseSetting && (
        <Card.Grid hoverable={false} style={gridStyle}>
          <Title level={5}>System Maintance</Title>
          <Form.Item name="WRITE_PROJECT" valuePropName="checked">
            <Checkbox>Can add project and edit project's profile</Checkbox>
          </Form.Item>
          <Form.Item name="WRITE_ROLE" valuePropName="checked">
            <Checkbox>Can add and edit roles</Checkbox>
          </Form.Item>
          <Form.Item name="WRITE_USER" valuePropName="checked">
            <Checkbox>Can add and edit users</Checkbox>
          </Form.Item>
          <Form.Item name="WRITE_FACULTY" valuePropName="checked">
            <Checkbox>Can add and edit faculties</Checkbox>
          </Form.Item>
          <Form.Item name="WRITE_DEPARTMENT" valuePropName="checked">
            <Checkbox>Can add and edit departments</Checkbox>
          </Form.Item>
          <Form.Item name="WRITE_BUDGET_CATEGORY" valuePropName="checked">
            <Checkbox>Can add and edit budget category</Checkbox>
          </Form.Item>
          <Form.Item name="WRITE_PROJECT_CATEGORY" valuePropName="checked">
            <Checkbox>
              Can add and edit project categories, including overridden scopes,
              role hierarchy, approval route template used in the project
              category
            </Checkbox>
          </Form.Item>
          <Form.Item name="WRITE_EMAIL_TEMPLATE" valuePropName="checked">
            <Checkbox>Can edit email templates and view email logs</Checkbox>
          </Form.Item>
          <Form.Item
            name="WRITE_APPROVAL_ROUTE_TEMPLATE"
            valuePropName="checked"
          >
            <Checkbox>Can add and edit approval route template</Checkbox>
          </Form.Item>
          <Form.Item name="WRITE_REPORTING_PERIOD" valuePropName="checked">
            <Checkbox>Can add and edit reporting period</Checkbox>
          </Form.Item>
          <Form.Item name="ASSIGN_APPROVER" valuePropName="checked">
            <Checkbox>
              Can assign application's approver (Please assign to PMS admin
              ONLY)
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={SCOPE_TYPES.VIEW_OTHER_REPORTS}
            valuePropName="checked"
          >
            <Checkbox>Can view other reports</Checkbox>
          </Form.Item>
          <Form.Item
            name={SCOPE_TYPES.WRITE_PROJECT_APPLICATION_SETTING}
            valuePropName="checked"
          >
            <Checkbox>Can add and edit funding application setting</Checkbox>
          </Form.Item>
        </Card.Grid>
      )}
    </Card>
  );
};

RolePremissionsForm.defaultProps = {
  includeReportControlType: true,
  includeViewProject: true,
  showSystemwiseSetting: true,
};

RolePremissionsForm.propTypes = {
  includeReportControlType: PropTypes.bool.isRequired,
  includeViewProject: PropTypes.bool.isRequired,
  showSystemwiseSetting: PropTypes.bool.isRequired,
};

export default RolePremissionsForm;
